/* RD Customz — withdrawal form (rdc-withdrawal section). Progressive: the form works without JavaScript. With JS the client time is added
   to the request and the receipt repeats what was sent (from sessionStorage, removed right after rendering; textContent only). */
const KEY = 'rdc_withdrawal_v1';
const form = document.querySelector('[data-rdc-withdrawal]');
const summary = document.querySelector('[data-rdc-withdrawal-summary]');

function store(f) {
  const val = (n) => f.querySelector(`[name="${n}"]`)?.value?.trim() || '';
  const scope = f.querySelector('[name="contact[Omvang]"]:checked');
  const label = (el) => el?.closest('label')?.textContent.trim() || '';
  const rows = [
    [f.querySelector('label[for="rdc-withdrawal-name"]'), val('contact[Naam]')],
    [f.querySelector('label[for="rdc-withdrawal-email"]'), val('contact[email]')],
    [f.querySelector('label[for="rdc-withdrawal-order"]'), val('contact[Bestelnummer]')],
    [f.querySelector('.rdc-withdrawal__scope legend'), label(scope)],
    [f.querySelector('label[for="rdc-withdrawal-products"]'), val('contact[Producten]')],
  ].filter(([, v]) => v).map(([l, v]) => [l.textContent.replace('*', '').trim(), v]);
  try { sessionStorage.setItem(KEY, JSON.stringify(rows)); } catch (e) { /* private mode: receipt without summary */ }
}

if (form && !summary) {
  form.addEventListener('submit', () => {
    const t = form.querySelector('[data-rdc-client-time]');
    if (t) t.value = new Date().toString();
    store(form);
  });
}
if (summary) {
  let rows = [];
  try { rows = JSON.parse(sessionStorage.getItem(KEY) || '[]'); sessionStorage.removeItem(KEY); } catch (e) { rows = []; }
  for (const [k, v] of rows) {
    const dt = document.createElement('dt'); dt.textContent = k;
    const dd = document.createElement('dd'); dd.textContent = v;
    summary.append(dt, dd);
  }
  if (rows.length) summary.hidden = false;
}
document.querySelector('[data-rdc-print]')?.addEventListener('click', () => window.print());
